import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { OrderElementService } from '@mavles/orders';
import { OrderApiService } from '@mavles/orders';
import { IOrderSearch } from '@mavles/orders';
import { RouteDataService } from '@mavles/shared';

@Component({
    selector: 'app-render-order',
    templateUrl: './render-order.component.html',
    styleUrl: './render-order.component.scss',
    standalone: false
})
export class RenderOrderComponent {
    @Input() order!: IOrderSearch;
    public elementService = inject(OrderElementService);
    public orderService = inject(OrderApiService);
    public routeData = inject(RouteDataService);
}


